import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ErrorStateRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 230px;
`;

export const Title = styled.p`
  ${typographyV2.bodyBase};
  margin-bottom: 12px;
`;
